module.exports = __webpack_public_path__ + "img/result-loan-step.c028b822.png";